import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function ForgeLayout() {
    useEffect(() => {
        // Set the background image when the component mounts
        ((document.body.style.backgroundImage =
            "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(/feathers.png)"),
            (document.body.style.backgroundSize = "auto"));
        document.body.style.backgroundRepeat = "repeat";

        // Optional cleanup function to reset the background on unmount
        return () => {
            document.body.style.backgroundImage = "";
            document.body.style.backgroundSize = "";
            document.body.style.backgroundRepeat = "";
        };
    }, []);

    return (
        <>
            <Outlet />
        </>
    );
}
